import axios from 'axios';
import $api from './axios.middlewares';
import { HTTP_HOST } from 'shared/consts/https';
import { Params, ThunkAxiosParams } from './types';

export const queryBuilder = (path: string, params: Params): string => {
	const paramsMap = Object.entries(params);
	let url: string = HTTP_HOST + path;

	if (paramsMap.length) {
		const searchParams = new URLSearchParams();
		paramsMap.forEach(([key, value]) =>
			searchParams.set(key, value?.toString()),
		);
		url += `?${searchParams.toString()}`;
	}

	return url;
};

const abortControllers: Record<string, AbortController> = {};

export const thunkAxiosRequest = async ({
	path = '',
	params = {},
	isApi = true,
	rejectWithValue,
	headers = {},
	method = 'get',
	abortWithParams = false,
	skipOfflineError = true,
}: ThunkAxiosParams) => {
	if (method) {
		const queryUrl = queryBuilder(path, params);
		const url = method === 'get' ? queryUrl : HTTP_HOST + path;

		const axiosMethod = axios[method];
		const apiMethod = $api[method];

		const request = isApi ? apiMethod : axiosMethod;

		if (!navigator.onLine && !skipOfflineError) {
			return rejectWithValue({
				status: 0,
				message: 'Ошибка сети',
				code: 'ERR_NETWORK',
			});
		}

		let requestKey = `${method}-`;

		if (abortWithParams) {
			requestKey += queryUrl;
		} else {
			requestKey += HTTP_HOST + path;
		}

		if (abortControllers[requestKey]) {
			abortControllers[requestKey].abort();
		}

		const controller = new AbortController();
		abortControllers[requestKey] = controller;

		try {
			const response = await request(
				url,
				method === 'get'
					? { headers, signal: controller.signal }
					: params,
				method === 'get'
					? undefined
					: { headers, signal: controller.signal },
			);

			if (!response || !response.data) {
				throw new Error('error');
			}

			delete abortControllers[requestKey];

			return response.data;
		} catch (error: any) {
			if (axios.isAxiosError(error) && error.code === 'ERR_CANCELED') {
				console.log('Request aborted:', error.message);
			} else {
				const status = error.request?.status;
				const message = error.message;
				const code = error.code;
				const fields = error.response.data;
				return rejectWithValue({ status, message, code, fields });
			}

			delete abortControllers[requestKey];

			throw error;
		}
	}
};
